app.views.base = Backbone.View.extend({
  el: 'body',
  parentEl: '',
  parentEvents: {},
  childEvents: {},
  events: function events() {
    return $.extend({}, this.parentEvents, this.childEvents);
  },
  getEl: function getEl(selector) {
    var $el = app.isEmpty(this.parentEl) ? this.$el : $(this.parentEl);
    if (app.isEmpty(selector)) {
      return $el;
    }
    return $el.find(selector);
  },
  init: function init() {
    this.callbackInit();
  },
  callbackInit: function callbackInit() {}
});